import React from "react";
import { Route, Routes } from "react-router-dom";
import CreditNotes from "./CreditNotes";
import Quotation from "./Quotation";
import PaymentIn from "./PaymentIn";
import SubSaleInvoice from "./SubSalesInvoice";
import ResourceNotFound from "../../Common/ResourceNotFound";
import SalesOrderDashboard from "./SalesOrderDashboard";
// import { ItemType } from "../../Services/ItemsService";
import LedgerTable from "../Master/Ledger/LedgerTable";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/UserSecurityFind";
import { useClient } from "../../Context/ClientContext";
import { useUser } from "../../../Context/UserContext";
import { IPermissionActionType } from "../Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import { SettingsSections } from "../../Services/SettingService";

const SalesNestedRoute = () => {
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  return (
    <Routes>
      <Route
        path="/invoices"
        element={
          findUserPremission(
            ["Voucher.Sales.Invoice.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SubSaleInvoice />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/proformaInvoices"
        element={
          findUserPremission(
            ["Voucher.Sales.ProformaInvoice.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.PInvoice],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <Quotation />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* <Route path={"/"} element={<SubSaleInvoice />} /> */}
      <Route
        path="/creditNotes"
        element={
          findUserPremission(
            ["Voucher.Sales.CreditNote.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.CrNote],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <CreditNotes />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/receipts"
        element={
          findUserPremission(
            ["Voucher.Sales.Receipt.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Receipt],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <PaymentIn />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/estimate"
        element={
          findUserPremission(
            ["Voucher.Sales.Estimate.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Quotation],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <Quotation />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/order"
        element={
          findUserPremission(
            ["Voucher.Sales.SalesOrder.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.SOrder],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesOrderDashboard />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      <Route
        path="/customers"
        element={
          findUserOnlyOnePremission(
            "Master.Ledger.Customer.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <LedgerTable
              ledgerByGroupsType={SearchLedgerByGroupsTypes.DebtorsOnly}
              showName={"Customer"}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* <Route path="/deliveryChallan" element={<DeliveryChallan />} /> */}

      {/* <Route
        path="/items"
        element={
          findUserOnlyOnePremission(
            "Master.Item.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <Items itemPage={ItemType.SalesItems} />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      /> */}

      <Route path="*" element={<ResourceNotFound pageHeight="100%" />} />
    </Routes>
  );
};

export default SalesNestedRoute;
